import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type PropsWithChildren,
} from "react";
interface ToastValue {
  show(message: string): void;
}
const ToastContext = createContext<ToastValue>({ show: () => undefined });
export function ToastProvider({ children }: PropsWithChildren) {
  const [message, setMessage] = useState("");
  const show = useCallback((next: string) => {
    setMessage(next);
    window.setTimeout(() => setMessage(""), 2400);
  }, []);
  const value = useMemo(() => ({ show }), [show]);
  return (
    <ToastContext.Provider value={value}>
      {children}
      {message && (
        <div
          role="status"
          className="fixed bottom-5 right-5 z-50 rounded-xl border border-brand/30 bg-panel px-4 py-3 text-sm text-white shadow-2xl"
        >
          {message}
        </div>
      )}
    </ToastContext.Provider>
  );
}
export const useToast = () => useContext(ToastContext);
